// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/breakpoint.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.V3AW0QccMnCpAl4axuXT {
  background-color: #F8FAFF;
  min-height: calc(100vh - 75px);
  width: 65%;
  padding: 16px 32px 16px 0;
  box-sizing: border-box;
}

.z0fjKx3wgXlTDAOY4uSl {
  margin-bottom: 24px;
}

.NwQEMNAlN_uEvafEMJWC {
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  position: absolute;
  bottom: 0;
}

.OIBiBTRfnKAC3BaXTLcX {
  margin-right: 32px;
}

.OOp8Tm5zzUmi3ar_vXqQ {
  border: 1px solid #E2E9FC;
  border-radius: 5px;
  text-align: left;

  height: 48px;
  width: 100%;
  margin-right: 16px;
  margin-bottom: 16px;
  padding: 0 16px;
  font-size: 14px;

  transition: .3s;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.OOp8Tm5zzUmi3ar_vXqQ input {
  margin-right: 8px;
}

.OOp8Tm5zzUmi3ar_vXqQ:hover, .wi85f_QZWTQCZ2cHnZn2 {
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.OOp8Tm5zzUmi3ar_vXqQ:disabled {
  background-color: #FAFBFE;
}

.OOp8Tm5zzUmi3ar_vXqQ:disabled:hover {
  border-color: #E2E9FC;
}

._m7hfe_IRCaolu7IAtKq img + img {
  margin-left: 8px;
}

.BSoejAbFvy09b_zvhFts, .YMFMmDo2EVCYpqfXKj5m {
  font-size: 11px;
  background: #FFE0E0;
  color: #E30101;
  border-radius: 3px;
  padding: 4px;
}

.BSoejAbFvy09b_zvhFts {
  margin-left: 8px;
}

.YMFMmDo2EVCYpqfXKj5m {
  width: max-content;
  font-weight: 700;
  letter-spacing: 0.005em;
  font-variant: small-caps;
  text-transform: uppercase;
  margin-left: 0;
}

.YMFMmDo2EVCYpqfXKj5m {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.YMFMmDo2EVCYpqfXKj5m .toQ0HImkBUXLYEgEvsh7 {
  font-size: 16px;
  margin-right: 4px;
}

.EsZBLQZ9uV267vMPhePd {
  font-family: Raleway, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
}

.Mkm0YpiWIYbpEciWfIzG {
  background-color: white;
  padding: 16px;
}
.PbGKJTRcQWDDKFNcUOk2 {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 4px;
  margin-top: 0;
}

.Fllvsl4ZIPhdlhMGKI_i {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
  margin-top: 4px;
}

.SE7iaCPI6WJxTHMeB0ug {
  display: flex;
  flex-direction: row;
  align-items: center;

  text-decoration: none;
  font-weight: 500;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
}

.RR8Kbhqf9VEevokjxpkt {
  width: 100%;
}

.kvYEkL1qE9RT_XEg5Wci {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};

  border-radius: 5px;
  width: 100%;
  height: 48px;
  padding: 8px;
  box-sizing: border-box;

  display: flex;
  justify-content: center;
  align-items: center;

  transition: .3s;
}

.kvYEkL1qE9RT_XEg5Wci a {
  width: 100%;

  font-weight: 500;
  color: white;
  text-decoration: none;
  text-align: center;
}

.kvYEkL1qE9RT_XEg5Wci:hover {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-dark"]};
  cursor: pointer;
}

.kvYEkL1qE9RT_XEg5Wci:hover a {
  color: white;
}

.msG1JI8_1N6gCsmHp8lL {
  display: none;
}

.S19FLPOjbQlKq7ZnhKVp {
  font-size: 16px;
  font-weight: 500;
}

.hupOONdBQ4RcOGwQKddw {
  height: 32px;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["tablet-l"]}) {
  .glZqLfuqhBra4VC7GQz1 {
    width: 100%;
    max-width: unset;
  }
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["tablet"]}) {
  .glZqLfuqhBra4VC7GQz1 {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  }

  .Mkm0YpiWIYbpEciWfIzG {
    scrollbar-color: rgba(0, 0, 0, 0.1) transparent; /* thumb and track color */
    scrollbar-width: thin;
  }

  .Mkm0YpiWIYbpEciWfIzG::-webkit-scrollbar {
    width: 5px;  /* for vertical scrollbars */
  }

  .Mkm0YpiWIYbpEciWfIzG::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
  }

  .V3AW0QccMnCpAl4axuXT {
    width: 100%;
    position: fixed;
    top: 75px;
    z-index: -10;

    max-height: calc(90vh - 75px);
    overflow-y: scroll;
  }

  .OOp8Tm5zzUmi3ar_vXqQ {
    width: 100%;
  }

  .EsZBLQZ9uV267vMPhePd {
    margin-top: 0;
    margin-bottom: 16px;
    text-align: center;
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Payements/PayementsForm/PayementsForm.module.css"],"names":[],"mappings":"AAMA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,UAAU;EACV,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;;EAEX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;;EAEzB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;;EAEhB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;;EAEf,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0DAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mDAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;;EAEnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8DAA8B;;EAE9B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;;EAEtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,eAAe;AACjB;;AAEA;EACE,WAAW;;EAEX,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,8DAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,+CAA+C,EAAE,0BAA0B;IAC3E,qBAAqB;EACvB;;EAEA;IACE,UAAU,GAAG,4BAA4B;EAC3C;;EAEA;IACE,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,SAAS;IACT,YAAY;;IAEZ,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":["@value colors: \"components/library/style/colors.css\";\n@value color-purple, color-purple-dark, color-text-subtle from colors;\n\n@value breakpoints: \"components/library/style/breakpoint.css\";\n@value desktop, laptop, tablet-l, tablet, mobile, mobile-xs from breakpoints;\n\n.container {\n  background-color: #F8FAFF;\n  min-height: calc(100vh - 75px);\n  width: 65%;\n  padding: 16px 32px 16px 0;\n  box-sizing: border-box;\n}\n\n.choiceButton {\n  margin-bottom: 24px;\n}\n\n.buttonGroup {\n  width: 100%;\n\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n\n  position: absolute;\n  bottom: 0;\n}\n\n.ghost {\n  margin-right: 32px;\n}\n\n.button {\n  border: 1px solid #E2E9FC;\n  border-radius: 5px;\n  text-align: left;\n\n  height: 48px;\n  width: 100%;\n  margin-right: 16px;\n  margin-bottom: 16px;\n  padding: 0 16px;\n  font-size: 14px;\n\n  transition: .3s;\n\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.button input {\n  margin-right: 8px;\n}\n\n.button:hover, .active {\n  border-color: color-purple;\n}\n\n.button:disabled {\n  background-color: #FAFBFE;\n}\n\n.button:disabled:hover {\n  border-color: #E2E9FC;\n}\n\n.card img + img {\n  margin-left: 8px;\n}\n\n.soon, .debug {\n  font-size: 11px;\n  background: #FFE0E0;\n  color: #E30101;\n  border-radius: 3px;\n  padding: 4px;\n}\n\n.soon {\n  margin-left: 8px;\n}\n\n.debug {\n  width: max-content;\n  font-weight: 700;\n  letter-spacing: 0.005em;\n  font-variant: small-caps;\n  text-transform: uppercase;\n  margin-left: 0;\n}\n\n.debug {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.debug .icon {\n  font-size: 16px;\n  margin-right: 4px;\n}\n\n.title {\n  font-family: Raleway, sans-serif;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 24px;\n}\n\n.content {\n  background-color: white;\n  padding: 16px;\n}\n.subtitle {\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  margin-bottom: 4px;\n  margin-top: 0;\n}\n\n.description {\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  color: color-text-subtle;\n  margin-top: 4px;\n}\n\n.link {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  text-decoration: none;\n  font-weight: 500;\n  margin-top: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.submit {\n  width: 100%;\n}\n\n.debugSubmit {\n  background-color: color-purple;\n\n  border-radius: 5px;\n  width: 100%;\n  height: 48px;\n  padding: 8px;\n  box-sizing: border-box;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  transition: .3s;\n}\n\n.debugSubmit a {\n  width: 100%;\n\n  font-weight: 500;\n  color: white;\n  text-decoration: none;\n  text-align: center;\n}\n\n.debugSubmit:hover {\n  background-color: color-purple-dark;\n  cursor: pointer;\n}\n\n.debugSubmit:hover a {\n  color: white;\n}\n\n.hide {\n  display: none;\n}\n\n.method {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.logo {\n  height: 32px;\n}\n\n@media screen and (max-width: tablet-l) {\n  .form {\n    width: 100%;\n    max-width: unset;\n  }\n}\n\n@media screen and (max-width: tablet) {\n  .form {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n  }\n\n  .content {\n    scrollbar-color: rgba(0, 0, 0, 0.1) transparent; /* thumb and track color */\n    scrollbar-width: thin;\n  }\n\n  .content::-webkit-scrollbar {\n    width: 5px;  /* for vertical scrollbars */\n  }\n\n  .content::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.1);\n    border-radius: 5px;\n  }\n\n  .container {\n    width: 100%;\n    position: fixed;\n    top: 75px;\n    z-index: -10;\n\n    max-height: calc(90vh - 75px);\n    overflow-y: scroll;\n  }\n\n  .button {\n    width: 100%;\n  }\n\n  .title {\n    margin-top: 0;\n    margin-bottom: 16px;\n    text-align: center;\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"components/library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-purple-dark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-dark"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"desktop": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["desktop"]}`,
	"laptop": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["laptop"]}`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["tablet-l"]}`,
	"tablet": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["tablet"]}`,
	"mobile": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["mobile"]}`,
	"mobile-xs": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["mobile-xs"]}`,
	"container": `V3AW0QccMnCpAl4axuXT`,
	"choiceButton": `z0fjKx3wgXlTDAOY4uSl`,
	"buttonGroup": `NwQEMNAlN_uEvafEMJWC`,
	"ghost": `OIBiBTRfnKAC3BaXTLcX`,
	"button": `OOp8Tm5zzUmi3ar_vXqQ`,
	"active": `wi85f_QZWTQCZ2cHnZn2`,
	"card": `_m7hfe_IRCaolu7IAtKq`,
	"soon": `BSoejAbFvy09b_zvhFts`,
	"debug": `YMFMmDo2EVCYpqfXKj5m`,
	"icon": `toQ0HImkBUXLYEgEvsh7`,
	"title": `EsZBLQZ9uV267vMPhePd`,
	"content": `Mkm0YpiWIYbpEciWfIzG`,
	"subtitle": `PbGKJTRcQWDDKFNcUOk2`,
	"description": `Fllvsl4ZIPhdlhMGKI_i`,
	"link": `SE7iaCPI6WJxTHMeB0ug`,
	"submit": `RR8Kbhqf9VEevokjxpkt`,
	"debugSubmit": `kvYEkL1qE9RT_XEg5Wci`,
	"hide": `msG1JI8_1N6gCsmHp8lL`,
	"method": `S19FLPOjbQlKq7ZnhKVp`,
	"logo": `hupOONdBQ4RcOGwQKddw`,
	"form": `glZqLfuqhBra4VC7GQz1`
};
export default ___CSS_LOADER_EXPORT___;
